module.exports = __webpack_public_path__ + "static/media/XXXIIIe.4a5a8619.png";